import React from 'react';

const NewTextLine = React.memo(({ text }) => {
  if (!text) {
    return null;
  }
  return text.split('\n').map((str, index) => <div key={`${index + 1}`} className="row"><div className="col">{str}</div></div>);
});

export default NewTextLine;